<template>
    <div class="vue-tooltip">
        <v-popover :open="open"
                   :trigger="trigger"
                   :popoverClass="popoverClass"
                   @hide="hide" >
            <div>
                <CircleSlot @click="toggle"></CircleSlot>
            </div>

            <template slot="popover">
                <div class="vue-tooltip__panel" v-if="panel">
                    <div class="vue-tooltip__panel-layout" @click="close"></div>

                    <div class="vue-tooltip__panel-content">
                        <div class="vue-tooltip__panel-close" @click="close">
                            <svg width="18"
                                 height="18"
                                 viewBox="0 0 18 18"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.2 1L1 17"
                                      stroke="white"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"/>
                                <path d="M1.8 1L17 17"
                                      stroke="white"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="vue-tooltip__panel-inner">
                            <slot></slot>
                        </div>
                    </div>
                </div>

                <slot v-else></slot>
            </template>
        </v-popover>
    </div>
</template>

<script>
    import CircleSlot from '../CircleSlot/CircleSlot';

    export default {
        components: {
            CircleSlot
        },

        data: () => ({
            open: false,
            trigger: window.innerWidth >= 960 ? 'hover' : 'manual',
            panel: window.innerWidth < 670
        }),

        computed: {
            popoverClass() {
                return this.panel ? 'is-panel' : 'is-basic'
            }
        },

        methods: {

            hide() {
                if (this.trigger === 'manual') {
                    this.open = false;
                }
            },

            toggle() {
                if (this.trigger === 'manual' && !this.panel) {
                    this.open = !this.open;
                } else {
                    this.open = true;
                }
            },

            close() {
                this.open = false;
            },

            windowResize() {
                this.trigger = window.innerWidth >= 960 ? 'hover' : 'manual';
                this.panel = window.innerWidth < 670;
                this.open = false;
            }
        },

        mounted() {
            window.addEventListener('resize', this.windowResize, false);
        },

        destroyed() {
            window.removeEventListener('resize', this.windowResize, false);
        }
    }
</script>

<style lang="scss">
    @import "./Tooltip";
</style>
